import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import translateString from '../../utils/Locales';
import { NineCellLoading } from 'react-loadingg';
import getClient from '../../services/getClient';
import Cookies from 'universal-cookie';
import '../landingPage/style.css';
import setAccountType from '../../services/setAccountType';
import Utils from '../../utils/utils';

let t = translateString;

export default class CheckoutPage extends React.Component {
    constructor(props) {
        super(props);
        
        this.paypal = React.createRef();

        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        
        const cookies = new Cookies();
        const db = cookies.get('db', { path: '/' });
        let cliente = await getClient('', '', db);

        this.setState({ isLoading: false, cliente: cliente });

        window.paypal.Buttons({
            style: {
                layout: 'vertical',
                color:  'blue',
                shape:  'rect',
                label:  'paypal'
            },
            createSubscription: function(data, actions) {
                return actions.subscription.create({
                  'plan_id': 'P-9JY76139BV831025UMLBPC5A'
                });
              },
            onApprove: async (data, actions) => { 
                this.setState({ isLoading: true });

                const cookies = new Cookies();
                const username = cookies.get('username', { path: '/' });
                const token = cookies.get('token', { path: '/' });
                let res = await setAccountType(username, token, 1, data.subscriptionID);
                if (res.result === 'ok') {
                    this.setState({ isLoading: false });
                    window.location.href = '/' + cookies.get('db', { path: '/' }) + '/#/app/complete';
                } else {
                    Utils.showError(t('errore_set'));
                }
            }, 
            onError: (err) => {
                console.error(err);
            }
        }).render(this.paypal.current);
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;
        return(
            <>
                <PageTitle title={t('concludi_ordine')} />
                { this.state.cliente.type === '0' && (
                    <div style={{ ...mainView }}>
                        <h4 style={{ fontWeight: 'bold' }}>{t('passa_account')} <span style={{ color: 'gold' }}>PREMIUM</span></h4>
                        <h6 style={{ fontWeight: 'bold', color: '#828282' }}>49 € {t('piu_iva')} {t('mese')}</h6>
                        <section style={{ marginTop: '30px', marginLeft: '20px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('free_1')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('free_2')} {t('premium_1')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_2')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/checked-1.png') } />
                                <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('premium_3')}</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', textAlign: 'left', paddingTop: '5px', paddingBottom: '5px' }}>
                                <img style={{ width: 15, height: 15, marginRight: '20px', marginTop: 2 }} src={ require('../../images/cancel-1.png') } />
                                <span style={{ color: 'darkgrey', fontWeight: 'bold' }}>{t('custom_1')}</span>
                            </div>
                        </section>
                        <section style={{ marginTop: 40, marginLeft: '20px' }}>
                            <h6 style={{ fontWeight: 'bold', color: '#828282' }}>{t('verifica_tuoi_dati')}</h6>

                            <p style={{ marginTop: 15, color: '#494949' }}><b>{t('rag_sociale')}</b> {this.state.cliente.ragioneSociale.replace(/\\/g, '')}</p>
                            <p style={{ marginTop: -10, color: '#494949' }}><b>{t('indirizzo')}:</b> {this.state.cliente.indirizzo.replace(/\\/g, '')}</p>
                            <p style={{ marginTop: -10, color: '#494949' }}><b>{t('citta')}:</b> {this.state.cliente.citta.replace(/\\/g, '')}</p>
                            <p style={{ marginTop: -10, color: '#494949' }}><b>{t('stato_provincia')}:</b> {this.state.cliente.provincia.replace(/\\/g, '')}</p>
                            <p style={{ marginTop: -10, color: '#494949' }}><b>{t('codice_postale')}:</b> {this.state.cliente.CAP.replace(/\\/g, '')}</p>
                        </section>
                        <section style={{ marginTop: 30, marginLeft: '20px' }}>
                        <p style={{ color: '#494949', fontSize: 12 }}><i>{t('conferma_pagamento')}</i></p>
                        </section>
                        <div style={{ marginTop: 40, marginLeft: '20px', width: 300 }} ref={this.paypal} />
                    </div>
                )}
            </>
        );
    }
}

const mainView = {
    backgroundColor: 'white', 
    borderRadius: '10px', 
    padding: '30px',
    boxShadow: '0px 2px 10px lightgrey', 
    width: '90%',
}